import { createAction } from "@reduxjs/toolkit";

import * as types from "./types";

export const setCalculationData = createAction<any>(types.SET_CALCULATION_DATA);
